<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";

import { Link, usePage } from "@inertiajs/vue3";
import BaseContent from "./BaseContent.vue";

const page = usePage();

const props = defineProps<{
    categories: object;
}>();
</script>

<template>
    <BaseCard
        :footer="{
            href: route('characters.index', {
                category_leaders: categories.map((e) => e.id),
                leader_skill_multiplier: 200,
                leader_skill_multiplier_strict: 'true',
            }),
        }"
    >
        <template #heading>Categories</template>

        <template #footer>Show 200% Leaders</template>

        <BaseContent class="flex flex-col gap-4">
            <div
                class="grid grid-cols-1 gap-1 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-1"
            >
                <Link
                    v-for="category in categories"
                    :data="{
                        categories: [category.id],
                    }"
                    :href="route('characters.index')"
                    class="font-medium"
                    >{{ category.name }}
                </Link>
            </div>
        </BaseContent>
    </BaseCard>
</template>

<style scoped></style>
